export default "/images/recruit-best.png?ac1692c58ba9f0565c657cadbd0a9a20";